
// On before slide change
$('.customer-review-slide').on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
    var slides = slick.$slides;
    
    // Remove existing wt-selected-slide class from all slides
    slides.removeClass('wt-selected-slide');
    
    // Add wt-selected-slide class to the second active slide (nextSlide + 1) after the change
    if (nextSlide !== undefined) {
        slides.eq(nextSlide + 1).addClass('wt-selected-slide');
    }
});

$('.customer-review-slide').on('init', function(event, slick){
    var slides = slick.$slides;
    
    // Add wt-selected-slide class to the second active slide (index 1)
    slides.eq(1).addClass('wt-selected-slide');
});

